// extracted by mini-css-extract-plugin
export default {"body":"DeleteTemplateModal_body__U0Fu2"};